import { Router } from '@/router';
import { MuiTheme } from '@/theme';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import type { FC } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App: FC = () => {
  return (
    <ThemeProvider theme={MuiTheme}>
      <Router />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
    </ThemeProvider>
  );
};

export default App;
